export enum SocialChatMessageState {
  RECEIVED,
  READ,
  FAILED,
}

export default SocialChatMessageState;
